export const GET_EMPLOYEE_DATA = 'profile@get-employee-data';
export const GET_INITIAL_SHIFT_PROFILE = 'profile@get-initial-shifts';